{ connect } = require 'react-redux'
HeaderComponent = require '../components/Header'

mapStateToProps = (state) ->
	auth: state.auth

Header = connect(mapStateToProps)(HeaderComponent)

module.exports = Header



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/Header.cjsx